const tab = {
  state: {
    editableTabsValue: '/bookShelf',
    editableTabs: [{title: '书架', name: '/bookShelf', close: false}]
  },
  mutations: {
    add_tabs: (state, tab) => { // 增加标签页方法
      // 在editableTabs中查找此界面是否已打开，否进入if
      if (state.editableTabs.findIndex(e => e.name === tab.path) === -1) {
        state.editableTabs.push({ // 添加当前标签页进入editableTabs
          title: tab.name,
          name: tab.path,
          close: true // 使除了首页标签页外其他都可关闭
        })
      }
      state.editableTabsValue = tab.path // 添加标签页后默认打开
    },
    change_tabs: (state, name) => { // 切换标签页方法
      // 将需打开标签页路由赋予editableTabsvalue
      state.editableTabsValue = name
    },
    init_tabs: (state) => {
      state.editableTabs = [{title: '书架', name: '/bookShelf', close: false}]
      state.editableTabsValue = '/bookShelf'
    }
  },
  actions: {
    // /** 登出 */
    // accountLogoutSubmit({commit}, params) {
    //   return new Promise((resolve, reject) => {
    //     UserCountService.logout(params).then((res) => {
    //       commit('ACCOUNT_LOGOUT_FAILURE');
    //       resolve()
    //     }).catch(err => {
    //       commit('ACCOUNT_LOGOUT_FAILURE');
    //       resolve()
    //     })
    //   })
    // }
  }
}

export default tab



// WEBPACK FOOTER //
// ./src/store/modules/tab.js